import React from 'react';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const AngelCtaSection = () => (
    <section id="cta" className="lp-cta">
        <div className="lp-cta-card" data-lp-reveal>
            <div className="lp-cta-glow" aria-hidden="true" />
            <div className="lp-cta-inner">
                <h2>Become the network that sets the standard.</h2>
                <p className="sub">A 20-minute demo using a company similar to your typical applicant. No commitment. No IT setup. Starts in days.</p>
                <a className="lp-cta-btn" href={KOALENDAR} target="_blank" rel="noopener noreferrer">
                    <span className="av"><img src={require('../../../../images/testimonials/richard-whitwell.png')} alt="" /></span>
                    Book a demo with Mark
                </a>
                <p className="fine">mark.bernstein@diligentsia.co.uk · diligentsia.co.uk</p>
            </div>
        </div>
    </section>
);

export default AngelCtaSection;
